import React, { Fragment, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { faAnglesUp, faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { LocalizedLink } from 'gatsby-plugin-i18n-l10n';
import { LayoutDataContext } from '../context/LayoutDataContext';

const Footer = () => {
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return <DefaultFooter scrollTop={scrollTop} />;
};

export default Footer;
const FollowIcon = () => (
  <a href="https://www.linkedin.com/company/cybersecuritylabtech" target="_blank" rel="noreferrer" aria-label="Odwiedź nasz profil na LinkedIn">
    <FontAwesomeIcon icon={faLinkedinIn} />
  </a>
),
  Services = () => (
    <Fragment>
      <li>
        <LocalizedLink to="/services/#desktop">Aplikacje webowe</LocalizedLink>
      </li>
      <li>
        <LocalizedLink to="/services/#mobile">Aplikacje mobilne</LocalizedLink>
      </li>
      <li>
        <LocalizedLink to="/services/#product">Projektowanie produktu</LocalizedLink>
      </li>
      <li>
        <LocalizedLink to="/services/#rnd">Projekty B+R</LocalizedLink>
      </li>
      <li>
        <LocalizedLink to="/services/#uxui">UX/UI Design</LocalizedLink>
      </li>
      <li>
        <LocalizedLink to="/services/#outsourcing">Outsourcing pracowników</LocalizedLink>
      </li>
      <li>
        <LocalizedLink to="/services/#cryptography">Kryptografia</LocalizedLink>
      </li>
      <li>
        <LocalizedLink to="/services/#2fa">Uwierzytelnianie</LocalizedLink>
      </li>
    </Fragment>
  ),
  Contact = ({ contact }) => (
    <Fragment>
      <li className="d-block-inline align-items-center">
        <FontAwesomeIcon icon={faLocationDot} className="me-3" />
        <div>
          <span>{`${contact.street},`}</span><br />
          <span>{`${contact.postCode} ${contact.city}`}</span>
        </div>
      </li>
      <li className="d-block-inline align-items-center">
        <FontAwesomeIcon icon={faEnvelope} className="me-3" />
        <span>
          <a href={`mailto:${contact.email}`}>{contact.email}</a>
        </span>
      </li>
      <li className="d-block-inline align-items-center">
        <FontAwesomeIcon icon={faPhone} className="me-3" />
        <span>
          <a href={`tel:${contact.phone?.replace(/ /g, '')}`}>{contact.phone}</a>
        </span>
      </li>
    </Fragment>
  ),
  FooterBottom = () => (
    <li>
      <LocalizedLink to="/privacy-policy/">Polityka prywatności</LocalizedLink>
    </li>
  ),
  CopyRight = () => (
    <p>
      © {new Date().getFullYear()} <LocalizedLink to="/">CYBER SECURITY LAB Sp. z o.o.</LocalizedLink> NIP: 9731075187
    </p>
  ),
  DefaultFooter = ({ scrollTop }) => {
    const { data } = useContext(LayoutDataContext);
    const contact = data?.strapiContact;

    return (
      <footer className="main-footer bg-blue">
        <div className="container">
          <div className="row justify-content-between text-white pt-75">
            <div className="col-lg-3 col-sm-4">
              <div className="footer-widget about-widget">
                <h5 className="footer-title">O nas</h5>
                <p>
                  Jesteśmy zespołem pasjonatów technologii, specjalizujących się w tworzeniu
                  cyberbezpiecznych aplikacji oraz kompleksowych rozwiązań, które wspierają rozwój firm w
                  dynamicznie zmieniającym się świecie cyfrowym.
                </p>
                <h5 className="pt-5">Obserwuj nas</h5>
                <div className="social-style-one">
                  <FollowIcon />
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-4">
              <div className="footer-widget menu-widget">
                <h5 className="footer-title">Oferta</h5>
                <ul>
                  <Services />
                </ul>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="footer-widget contact-info-widget">
                <h5 className="footer-title">Kontakt</h5>
                <ul>
                  {contact && <Contact contact={contact} />}
                </ul>
              </div>
              <div className="footer-widget contact-info-widget">
                <h5 className="footer-title">Kariera</h5>
                <p>Zobacz aktualne oferty pracy:</p>
                <LocalizedLink to="/career/" className="theme-btn sliding-end" target="_blank" rel="noreferrer">
                  Zobacz oferty pracy
                </LocalizedLink>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright-area bg-dark-blue text-white rel">
          <div className="container">
            <div className="copyright-inner">
              <CopyRight />
              <ul className="footer-menu">
                <FooterBottom />
              </ul>
            </div>
          </div>
          {/* Scroll top button */}
          <button
            className="scroll-top scroll-to-target"
            data-target="html"
            style={{ display: 'inline-block' }}
            aria-label="Przewiń do góry strony"
            onClick={() => scrollTop()}>
            <span className="sr-only">Do góry</span>
            <FontAwesomeIcon icon={faAnglesUp} />
          </button>
        </div>
      </footer>
    );
  };

